import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import ErrorInfo from '../../views/etc/ErrorInfo';

const NotAuthorized = (): JSX.Element => {
  const content = '해당 페이지를 조회할 수 있는 권한이 없어요!\n메뉴를 이용하려면 최상위 관리자에게 요청해주세요.';

  return (
    <PageTemplate>
      <ErrorInfo code={403} message={'접근할 수 있는 권한이 없습니다'} content={content} />
    </PageTemplate>
  );
};

export default NotAuthorized;
